import { HiCheck, HiInformationCircle, HiX } from 'react-icons/hi';
import { BiSolidErrorAlt } from 'react-icons/bi';
import Portal from '../../portal';
import { useEffect } from 'react';
import { useToastContext } from './toast.context';

function Toast() {
  const { toasts, hideToast } = useToastContext();

  useEffect(() => {
    const timers = toasts.map((toast) => {
      return setTimeout(() => {
        hideToast(toast.id);
      }, toast.expireTime || 3000);
    });

    return () => timers.forEach(timer => clearTimeout(timer));
  }, [toasts, hideToast]);

  return (
    <Portal>
      <div className="space-y-4 fixed top-0 right-0 p-4" style={{ zIndex: 9999 }}>
        {toasts.map((toast) => (
          <div
            key={toast.id}
            className="relative bg-white text-black shadow-md p-4 rounded-md flex items-center"
            style={{ zIndex: 9999 }}
          >
            <button
              onClick={() => hideToast(toast.id)}
              className="absolute top-0 right-0 mt-1 mr-1 p-1 text-gray-500 hover:text-gray-700 bg-transparent"
              style={{ lineHeight: 0 }}
            >
              <HiX className="h-4 w-4" />
            </button>

            {toast.type === 'success' && (
              <div className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-greenPrimary/10 text-greenPrimary">
                <HiCheck />
              </div>
            )}
            {toast.type === 'info' && (
              <div className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-greenPrimary/10 text-cyan-400">
                <HiInformationCircle />
              </div>
            )}
            {toast.type === 'error' && (
              <div className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-redPrimary/10 text-redPrimary">
                <BiSolidErrorAlt />
              </div>
            )}
            <div className="ml-3 text-sm font-normal">
              <p className="whitespace-normal break-words">{toast.text}</p>
            </div>
          </div>
        ))}
      </div>
    </Portal>
  );
}

export default Toast;
